<template>
  <div class="section container mx-auto mt-32 mb-40 w-9/12">
    <h1 class="text-5xl mb-14 mx-auto font-bold text-center text-gray-800">{{librosqc.title}}</h1>
    <p class="text-center mb-20">{{librosqc.subtitle}}</p> 
    <div class="mapa flex justify-evenly z-10">
      <img class="w-full" :src="img_mapa" >

      <!-- <div class="item flex flex-col justify-center items-center ">
        <div class="circle rounded-full bg-theme-sky w-16 h-16 text-white text-center flex items-center justify-center"><span class="text-bold text-2xl">RED</span></div>
        <div class="nombre text-center mt-2 text-sm">PARADA<br>LAPRIDA</div>
      </div>  
      <div class="item flex flex-col justify-center items-center ">
        <div class="circle rounded-full bg-theme-sky w-16 h-16 text-white text-center flex items-center justify-center"><span class="text-bold text-2xl">RED</span></div>
        <div class="nombre text-center mt-2 text-sm">PARADA<br>ÁLVAREZ</div>
      </div>  
      <div class="item flex flex-col justify-center items-center ">
        <div class="circle rounded-full bg-theme-sky w-16 h-16 text-white text-center flex items-center justify-center"><span class="text-bold text-2xl">RED</span></div>
        <div class="nombre text-center mt-2 text-sm">PARADA<br>URQUIZA</div>
      </div>  
      <div class="item flex flex-col justify-center items-center ">
        <div class="circle rounded-full bg-theme-sky w-16 h-16 text-white text-center flex items-center justify-center"><span class="text-bold text-2xl">RED</span></div>
        <div class="nombre text-center mt-2 text-sm">PARADA<br>SAN MARTÍN</div>
      </div>  
      <div class="item flex flex-col justify-center items-center ">
        <div class="circle rounded-full bg-theme-sky w-16 h-16 text-white text-center flex items-center justify-center"><span class="text-bold text-2xl">RED</span></div>
        <div class="nombre text-center mt-2 text-sm">PARADA<br>YRIGOYEN</div>
      </div>  
      <div class="item flex flex-col justify-center items-center ">
        <div class="circle rounded-full bg-theme-sky w-16 h-16 text-white text-center flex items-center justify-center"><span class="text-bold text-2xl">RED</span></div>
        <div class="nombre text-center mt-2 text-sm">PARADA<br>MALAVER</div>
      </div>   -->

    </div>
    <!-- <div class="h-1 bg-theme-sky z-0 -mt-20"></div>  -->

  </div>
  
</template>

<script>
    export default {
        
        props: {
            'librosqc':Object
        },
        data(){
            const img_mapa = require('@/assets/images/home/mapa3.jpg')
            return {
              img_mapa
            }
        },

    }

</script>
  

  